module.exports = __webpack_public_path__ + "static/media/el-ementa.87ccde40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/network/el-ementa.png
// module id = 652
// module chunks = 0